<template>
	<sf-data-table
		ref="dataTable"
		:paging="false"
		index
		:columns="powTourRgstManagementCols"
		:rows="rows"
		:excel="false"
		:stripe="false"
		selection
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'mark'">
				<template v-if="slotProps.row.vbgStrtDd <= getToday && !slotProps.row.insnRsltCd">
					<i class="icon-sf-error warned"></i>
				</template>
			</template>
			<template v-if="slotProps.column.property === 'vbgStrtDd'">
				<span :class="slotProps.row.vbgStrtDd <= getToday && !slotProps.row.insnRsltCd && 'warned'">{{ slotProps.row.vbgStrtDd }}</span>
			</template>
			<template v-if="slotProps.column.property === 'rmk'">
				<div class="position-relative h-100">
					<el-input
						class="pr-2"
						:value="slotProps.row[slotProps.column.property]"
						:readonly="isReadonly"
						@input="val => onChange(val, slotProps)"
					></el-input>
				</div>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourRgst/store/helpers';
import qmsUtils from '@/qmsUtils';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		getToday() {
			return this.$moment().format('YYYY-MM-DD');
		},
		rows() {
			return this.resultList;
		},
		powTourRgstManagementCols() {
			//그리드 컬럼
			return [
				{
					prop: 'mark',
					minWidth: '40px',
					custom: true,
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001137'), // 라인
					prop: 'powLnCd',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001137'), // 라인
					prop: 'powLnNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001030'), //공정
					prop: 'powPrvsCd',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001030'), //공정
					prop: 'powPrvsNm',
					minWidth: '160px'
				},
				{
					label: this.getMessage_('QWCC001301'), //검사내용
					minWidth: '150px',
					sortable: false,
					children: [
						{
							label: this.getMessage_('QWCC001213'), // 방식
							prop: 'insnWayCd',
							minWidth: '1px'
						},
						{
							label: this.getMessage_('QWCC001213'), // 방식
							prop: 'insnWayNm',
							minWidth: '120px'
						},
						{
							label: this.getMessage_('QWCC001215'), // 항목
							prop: 'insnPrvsSbc',
							minWidth: '350px'
						},
						{
							label: this.getMessage_('QWCC001216'), // 주기
							prop: 'insnCyclCd',
							minWidth: '1px'
						},
						{
							label: this.getMessage_('QWCC001216'), // 주기
							prop: 'insnCyclNm',
							minWidth: '80px'
						},

						{
							label: this.getMessage_('QWCC001380'), //예정일
							prop: 'vbgStrtDd',
							minWidth: '100px',
							custom: true
						}
					]
				},
				{
					label: this.getMessage_('RCMS000093'), // 결과
					prop: 'insnRsltCd',
					minWidth: '80px',
					form: {
						type: 'select',
						options: this.gridInsnRsltCdList,
						isDisabled: this.isDisabled, //작성일자가 있는 건은 수정을 못하게 한다.
						placeholder: this.getMessage_('RCMS000093')
					}
				},
				{
					label: this.getMessage_('QWCC000906'), // 비고
					prop: 'rmk',
					minWidth: '350px',
					custom: true
					// form: {
					// 	type: 'input',
					// 	isDisabled: this.isDisabled //작성일자가 있는 건은 수정을 못하게 한다.
					// }
				}
			];
		},
		isReadonly() {
			return !this.resultMaster.pprrDd ? false : true;
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}
			this.$emit('Refresh');
		},
		gridCheckRowData() {
			/* 상위 저장 버튼시 이 함수를 호출함 체크된행만 리턴함*/
			return this.$refs.dataTable.getSelectedRows();
		},
		isDisabled({ row }) {
			if (!this.resultMaster.pprrDd) return false;
			else return true;
		},
		selectUnCheck() {
			//체크박스 클리어
			if (this.$refs.dataTable.getSelectedRows().length <= 0) {
				this.resultList.forEach(row => {
					row.oldInsnDd && this.$refs.dataTable.getTable().toggleRowSelection(row);
				});
			}
		},
		selectCheck() {
			//체크박스 체크
			this.resultList.forEach(row => {
				row.oldInsnDd && this.$refs.dataTable.getTable().toggleRowSelection(row);
			});
		},
		onChange(value, slotProps) {
			const key = slotProps.column.property;
			if (key === 'rmk') {
				slotProps.row.rmk = qmsUtils.getLimitedByteText(value, 200);
			}
		}
	},
	async created() {
		try {
			//결과 콤보
			await this.getCommCodes_({ key: 'gridInsnRsltCdList', codeType: 'INSN_RSLT' });
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
		}
	},
	mounted() {
		this.selectCheck();
	}
};
</script>

<style lang="scss" scoped>
.warned {
	color: red;
	font-weight: bold;
}
</style>
